

import { useDispatch, useSelector } from 'react-redux';
import { Controller } from 'react-hook-form';
import { useState } from 'react'

import { getFormErrorMessage } from '../../../config/global';
import { DISPLAY_OPTIONS, POSITION_OPTIONS } from '../../../Constants/apps';
import { setClockSettings, setRssSettings } from '../../../redux/Slices/Apps/appsSlice';
import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

import Sketch from '@uiw/react-color-sketch';
import { useTranslation } from 'react-i18next';







const TextColorInput = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const clockSettings = useSelector((state) => state.apps.clockSettings);
    const [displayColorPicker, setDisplayColorPicker] = useState({
        text: false,
        bg: false
    });

    const colorPickerHandler = (key) => {
        setDisplayColorPicker(prev => ({ ...prev, [key]: !prev[key] }))
    }

    return (
        <>
            <div className="w-100">
                <label className={`block text-sm mb-1`}>{t('clock.text_color')}</label>
                <div className="border-1 p-2 rounded d-flex position-relative">
                    <Sketch
                        color={clockSettings.text_color}
                        disableAlpha={false}
                        onChange={(color) => {
                            dispatch(setClockSettings({ text_color: color.hexa }))
                        }}
                        onMouseLeave={() => colorPickerHandler("text")}
                        className={`right-[0] position-absolute color_picker ${displayColorPicker.text ? "d-block" : "d-none"}`}
                    />
                    <div className='me-3 cursor-pointer border-1'
                        onClick={() => colorPickerHandler("text")}
                        style={{ backgroundColor: `${clockSettings.text_color}`, width: "25px", height: "25px" }} >
                    </div>
                    <div className='border-bottom' >{clockSettings.text_color}</div>
                </div>
            </div>


        </>
    )
}

const BgColorInput = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const clockSettings = useSelector((state) => state.apps.clockSettings);
    const [displayColorPicker, setDisplayColorPicker] = useState({
        text: false,
        bg: false
    });


    const colorPickerHandler = (key) => {
        setDisplayColorPicker(prev => ({ ...prev, [key]: !prev[key] }))
    }

    function hexToRgba(hex, alpha) {
        let r = 0, g = 0, b = 0;

        if (hex.length === 4) {
            r = parseInt(hex[1] + hex[1], 16);
            g = parseInt(hex[2] + hex[2], 16);
            b = parseInt(hex[3] + hex[3], 16);
        } else if (hex.length === 7) {
            r = parseInt(hex.slice(1, 3), 16);
            g = parseInt(hex.slice(3, 5), 16);
            b = parseInt(hex.slice(5, 7), 16);
        }

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }


    return (
        <>


            <div className="w-100">
                <label className={`block text-sm mb-1`}>{t('clock.background_color')}</label>
                <div className="border-1 p-2 rounded d-flex position-relative">
                    <Sketch
                        color={clockSettings.bg_color_main}
                        disableAlpha={false}
                        onChange={(color) => {
                            const shadowColor = hexToRgba(color.hexa, 0.7)
                            dispatch(setClockSettings({ shadow_color: shadowColor }))
                            dispatch(setClockSettings({ bg_color_main: color.hexa }))
                        }}
                        onMouseLeave={() => colorPickerHandler("text")}
                        className={`right-[0] position-absolute color_picker ${displayColorPicker.text ? "d-block" : "d-none"}`}
                    />
                    <div className='me-3 cursor-pointer border-1'
                        onClick={() => colorPickerHandler("text")}
                        style={{ backgroundColor: `${clockSettings.bg_color_main}`, width: "25px", height: "25px" }} >
                    </div>
                    <div className='border-bottom' >{clockSettings.bg_color_main}</div>
                </div>
            </div>

        </>
    )
}

const CardColorInput = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const clockSettings = useSelector((state) => state.apps.clockSettings);
    const [displayColorPicker, setDisplayColorPicker] = useState({
        text: false,
        bg: false
    });



    const colorPickerHandler = (key) => {
        setDisplayColorPicker(prev => ({ ...prev, [key]: !prev[key] }))
    }


    function lightenColor(hex, percent) {
        let num = parseInt(hex.replace("#", ""), 16);
        let amt = Math.round(2.55 * percent);
        let R = (num >> 16) + amt;
        let G = ((num >> 8) & 0x00FF) + amt;
        let B = (num & 0x0000FF) + amt;

        return (
            "#" +
            (
                0x1000000 +
                (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                (B < 255 ? (B < 1 ? 0 : B) : 255)
            )
                .toString(16)
                .slice(1)
        );
    }


    return (
        <>

            <div className="w-100">
                <label className={`block text-sm mb-1`}>{t('clock.card_color')}</label>
                <div className="border-1 p-2 rounded d-flex position-relative">
                    <Sketch
                        color={clockSettings.bg_color_sub}
                        disableAlpha={false}
                        onChange={(color) => {
                            const newBg = color.hex;
                            const lighter = lightenColor(newBg, 10);
                            dispatch(setClockSettings({ bg_color_sub: newBg }));
                            dispatch(setClockSettings({ bg_color_flip: lighter }));
                        }}
                        onMouseLeave={() => colorPickerHandler("text")}
                        className={`right-[0] position-absolute color_picker ${displayColorPicker.text ? "d-block" : "d-none"}`}
                    />
                    <div className='me-3 cursor-pointer border-1'
                        onClick={() => colorPickerHandler("text")}
                        style={{ backgroundColor: `${clockSettings.bg_color_sub}`, width: "25px", height: "25px" }} >
                    </div>
                    <div className='border-bottom' >{clockSettings.bg_color_sub}</div>
                </div>
            </div>
        </>
    )
}

export { TextColorInput, BgColorInput, CardColorInput }